import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import Servidor from "../config/Servidor";
import "./ConfigurarCobrador.css";

export default function ConfigurarCobrador() {    

  const { id } = useParams();

  const [cobrador, setCobrador] = useState(null);
  const [supervisor, setSupervisor] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

const [modalMes, setModalMes] = useState(false);
const [modalBorrar, setModalBorrar] = useState(false);
const [mesesAgregar, setMesesAgregar] = useState("");

  useEffect(() => {

    cargarCobrador();

  }, [id]);

const formatearFecha = (fecha) => {

  if (!fecha) {
    return "—";
  }

  const fechaObjeto =
    fecha instanceof Date
      ? fecha
      : new Date(fecha);

  if (isNaN(fechaObjeto.getTime())) {
    return String(fecha);
  }

  const dia = String(
    fechaObjeto.getDate()
  ).padStart(2, "0");

  const mes = String(
    fechaObjeto.getMonth() + 1
  ).padStart(2, "0");

  const anio =
    fechaObjeto.getFullYear();

  return `${dia}-${mes}-${anio}`;
};

  const cargarCobrador = async () => {

    try {

      setCargando(true);
      setError("");

      const res = await axios.get(
        `${Servidor.IP}/configurar/cobrador/${id}`
      );

      if (!res.data?.ok) {

        setError(
          res.data?.msg ||
          "No se pudo obtener el cobrador"
        );

        return;
      }

      setCobrador(
        res.data.usuario
      );

      setSupervisor(
        res.data.supervisor || null
      );

    } catch (err) {

      console.error(
        "Error obteniendo cobrador:",
        err
      );

      setError(
        err.response?.data?.msg ||
        "Error al conectar con el servidor"
      );

    } finally {

      setCargando(false);

    }

  };


  const nombreCompleto = (persona) => {

    return [
      persona?.nombre,
      persona?.primerapellido,
      persona?.segundoapellido
    ]
      .filter(Boolean)
      .join(" ")
      .trim();

  };


  const mostrarValor = (valor) => {

    if (
      valor === null ||
      valor === undefined ||
      valor === ""
    ) {
      return "—";
    }

    return String(valor);

  };

const calcularNuevaFecha = () => {

  if (
    !cobrador?.fecha_vencimiento ||
    !mesesAgregar ||
    Number(mesesAgregar) < 1
  ) {
    return null;
  }

  const fecha = new Date(
   cobrador.fecha_vencimiento
  );

  if (isNaN(fecha.getTime())) {
    return null;
  }

  fecha.setMonth(
    fecha.getMonth() + Number(mesesAgregar)
  );

  return fecha;
};


const abrirModalMes = () => {
  setMesesAgregar("");
  setModalMes(true);
};


const confirmarAumentoMes = async () => {
  const meses = Number(mesesAgregar);

  if (!mesesAgregar || !Number.isInteger(meses) || meses < 1) {
    alert("Ingrese una cantidad válida de meses.");
    return;
  }

  try {
    const res = await axios.put(
      `${Servidor.IP}/configurar/usuarios/${id}/aumentar-mes`,
      {
        meses,
      }
    );

    if (!res.data?.ok) {
      alert(
        res.data?.msg ||
        "No se pudo aumentar los meses."
      );
      return;
    }

    setModalMes(false);
    setMesesAgregar("");

    await cargarCobrador();

    alert(
      res.data?.msg ||
      "Meses aumentados correctamente."
    );

  } catch (err) {
    console.error(
      "Error aumentando meses:",
      err
    );

    alert(
      err.response?.data?.msg ||
      "Error al aumentar los meses."
    );
  }
};


const abrirModalBorrar = () => {
  setModalBorrar(true);
};


const confirmarBorrado = async () => {
  try {
    const res = await axios.delete(
      `${Servidor.IP}/configurar/usuarios/${id}`
    );

    if (!res.data?.ok) {
      alert(
        res.data?.msg ||
        "No se pudo borrar el usuario."
      );
      return;
    }

    setModalBorrar(false);

    alert(
      res.data?.msg ||
      "Usuario eliminado correctamente."
    );

    navigate(-1);

  } catch (err) {
    console.error(
      "Error borrando usuario:",
      err
    );

    alert(
      err.response?.data?.msg ||
      "Error al borrar el usuario."
    );
  }
};
  if (cargando) {

    return (
      <div className="configurar-cobrador-page">

        <div className="configurar-cobrador-cargando">
          Cargando información...
        </div>

      </div>
    );

  }


  if (error || !cobrador) {

    return (
      <div className="configurar-cobrador-page">

        <div className="configurar-cobrador-error">

          <h2>
            No se pudo cargar la información
          </h2>

          <p>
            {error || "Cobrador no encontrado"}
          </p>

        </div>

      </div>
    );

  }


  const nombre =
    nombreCompleto(cobrador) ||
    cobrador.usuario ||
    "Sin nombre";


  const nombreSupervisor =
    supervisor
      ? (
          nombreCompleto(supervisor) ||
          supervisor.usuario ||
          "Sin nombre"
        )
      : "Sin supervisor";


  return (
    <div className="configurar-cobrador-page">

      <div className="configurar-cobrador-container">


        {/* PERFIL */}

        <div className="configurar-cobrador-profile">

          <div className="configurar-cobrador-avatar">

            {nombre
              .charAt(0)
              .toUpperCase()}

          </div>


      <div className="configurar-cobrador-profile-info">

  <div className="configurar-cobrador-nombre-row">

    <h1>
      {nombre}
    </h1>

    <div className="configurar-cobrador-menu">

      <button
        className="configurar-cobrador-menu-btn"
        onClick={(e) => {
          e.stopPropagation();
          const menu =
            document.getElementById(
              "menu-configurar-cobrador"
            );

          if (menu) {
            menu.style.display =
              menu.style.display === "block"
                ? "none"
                : "block";
          }
        }}
      >
        ⋮
      </button>

      <div
        id="menu-configurar-cobrador"
        className="configurar-cobrador-menu-dropdown"
        style={{ display: "none" }}
      >

        <button onClick={abrirModalMes}>
          📅 Aumentar meses
        </button>

        <button
          className="menu-borrar"
          onClick={abrirModalBorrar}
        >
          🗑️ Borrar usuario
        </button>

      </div>

    </div>

  </div>

  <p>
    @{cobrador.usuario}
  </p>

            <div className="configurar-cobrador-badges">

              <span className="configurar-cobrador-rol">
                Cobrador
              </span>


              <span
                className={
                  Number(cobrador.activo) === 1
                    ? "configurar-cobrador-activo"
                    : "configurar-cobrador-inactivo"
                }
              >
                {Number(cobrador.activo) === 1
                  ? "Activo"
                  : "Inactivo"}
              </span>

            </div>

          </div>

        </div>

 {/* DATOS PERSONALES */}

        <section className="configurar-cobrador-section">

          <h2>
            Datos personales
          </h2>


          <div className="configurar-cobrador-grid">

            <div className="configurar-cobrador-dato">
              <span>Cédula</span>
              <strong>
                {mostrarValor(
                  cobrador.cedula
                )}
              </strong>
            </div>


            <div className="configurar-cobrador-dato">
              <span>Nombre</span>
              <strong>
                {mostrarValor(
                  cobrador.nombre
                )}
              </strong>
            </div>


            <div className="configurar-cobrador-dato">
              <span>Primer apellido</span>
              <strong>
                {mostrarValor(
                  cobrador.primerapellido
                )}
              </strong>
            </div>


            <div className="configurar-cobrador-dato">
              <span>Segundo apellido</span>
              <strong>
                {mostrarValor(
                  cobrador.segundoapellido
                )}
              </strong>
            </div>


            <div className="configurar-cobrador-dato">
              <span>Celular</span>
              <strong>
                {mostrarValor(
                  cobrador.celular
                )}
              </strong>
            </div>


            <div className="configurar-cobrador-dato">
              <span>Fecha nacimiento</span>
              <strong>
                    {formatearFecha(cobrador.fechan)}
              </strong>
            </div>

          </div>

        </section>
        {/* DATOS USUARIO */}

        <section className="configurar-cobrador-section">

          <h2>
            Datos del usuario
          </h2>


          <div className="configurar-cobrador-grid">


            <div className="configurar-cobrador-dato">
              <span>Usuario</span>
              <strong>
                {mostrarValor(
                  cobrador.usuario
                )}
              </strong>
            </div>

            <div className="configurar-cobrador-dato">
              <span>Rol</span>
              <strong>
                {mostrarValor(
                  cobrador.rol_nombre ||
                  "Cobrador"
                )}
              </strong>
            </div>


            <div className="configurar-cobrador-dato">
              <span>Activo</span>
              <strong>
                {Number(cobrador.activo) === 1
                  ? "Sí"
                  : "No"}
              </strong>
            </div>


            <div className="configurar-cobrador-dato">
              <span>Fecha</span>
              <strong>
               {formatearFecha(cobrador.fecha)}

              </strong>
            </div>


            <div className="configurar-cobrador-dato">
              <span>Fecha vencimiento</span>
              <strong>
                 {formatearFecha(cobrador.fecha_vencimiento)}
              </strong>
            </div>


            <div className="configurar-cobrador-dato">
              <span>Meses pagados</span>
              <strong>
                {mostrarValor(
                  cobrador.meses_pagados
                )}
              </strong>
            </div>

          </div>

        </section>


       


        {/* SUPERVISOR */}

        <section className="configurar-cobrador-section">

          <h2>
            Supervisor
          </h2>


          {supervisor ? (

            <div className="configurar-cobrador-supervisor">

              <div className="configurar-cobrador-supervisor-avatar">

                {nombreSupervisor
                  .charAt(0)
                  .toUpperCase()}

              </div>


              <div>

                <strong>
                  {nombreSupervisor}
                </strong>

                <span>
                  @{supervisor.usuario}
                </span>

                <small>
                  ID usuario:{" "}
                  {supervisor.id_usuario}
                </small>

              </div>

            </div>

          ) : (

            <div className="configurar-cobrador-sin-supervisor">

              Este cobrador no tiene un supervisor
              asignado mediante la tabla de asignaciones.

            </div>

          )}

        </section>

      </div>
{/* MODAL AUMENTAR MESES */}

{modalMes && (
  <div
    className="configurar-modal-overlay"
    onClick={() => setModalMes(false)}
  >

    <div
      className="configurar-modal"
      onClick={(e) => e.stopPropagation()}
    >

      <div className="configurar-modal-header">

        <div>
          <h2>Aumentar meses</h2>

          <p>
            Agrega meses al vencimiento del cobrador.
          </p>
        </div>

        <button
          className="configurar-modal-cerrar"
          onClick={() => setModalMes(false)}
        >
          ×
        </button>

      </div>


      <div className="configurar-modal-body">

        <label>
          Cantidad de meses
        </label>

        <input
          type="number"
          min="1"
          step="1"
          value={mesesAgregar}
          onChange={(e) =>
            setMesesAgregar(e.target.value)
          }
          placeholder="Ej. 1"
          autoFocus
        />


        <div className="configurar-fechas-preview">

          <div className="fecha-preview">

            <span>
              Vencimiento actual
            </span>

            <strong>
             {formatearFecha(
               cobrador.fecha_vencimiento
              )}
            </strong>

          </div>


          <div className="fecha-flecha">
            →
          </div>


          <div className="fecha-preview nueva">

            <span>
              Nuevo vencimiento
            </span>

            <strong>
              {formatearFecha(
                calcularNuevaFecha()
              )}
            </strong>

          </div>

        </div>

      </div>


      <div className="configurar-modal-footer">

        <button
          className="configurar-modal-cancelar"
          onClick={() => setModalMes(false)}
        >
          Cancelar
        </button>

        <button
          className="configurar-modal-confirmar"
          onClick={confirmarAumentoMes}
        >
          Confirmar
        </button>

      </div>

    </div>

  </div>
)}


{/* MODAL BORRAR */}

{modalBorrar && (
  <div
    className="configurar-modal-overlay"
    onClick={() => setModalBorrar(false)}
  >

    <div
      className="configurar-modal configurar-modal-borrar"
      onClick={(e) => e.stopPropagation()}
    >

      <button
        className="borrar-cerrar"
        onClick={() => setModalBorrar(false)}
      >
        ×
      </button>


      <div className="configurar-modal-icono-borrar">
        🗑️
      </div>


      <h2>
        ¿Borrar usuario?
      </h2>


      <p>
        Estás a punto de eliminar al cobrador:
      </p>


      <strong className="configurar-modal-usuario">
        {nombre}
      </strong>


      <p className="configurar-modal-advertencia">
        Esta acción eliminará permanentemente
        al usuario y sus datos relacionados.
        No se puede deshacer.
      </p>


      <div className="configurar-modal-footer">

        <button
          className="configurar-modal-cancelar"
          onClick={() => setModalBorrar(false)}
        >
          Cancelar
        </button>

        <button
          className="configurar-modal-eliminar"
          onClick={confirmarBorrado}
        >
          Sí, borrar
        </button>

      </div>

    </div>

  </div>
)}
    </div>
  );
}